var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320,42.7c-77,0-138.7,35.1-183.6,76.9c-44.6,41.4-74.5,90.9-88.5,124.9c-3.1,7.6-3.1,15.9,0,23.5 c14.1,34.1,43.9,83.6,88.5,125c44.9,41.7,106.6,76.9,183.6,76.9s138.7-35.1,183.6-76.9c44.6-41.5,74.5-90.9,88.6-125 c3.1-7.6,3.1-15.9,0-23.5c-14.2-34.1-44-83.6-88.6-125C458.7,77.8,396.9,42.7,320,42.7z M182.7,256.2c0-75.8,61.5-137.3,137.3-137.3 s137.3,61.5,137.3,137.3S395.8,393.5,320,393.5S182.7,332,182.7,256.2z M320,195.2c0,33.6-27.4,61-61,61c-6.8,0-13.3-1.2-19.4-3.1 c-5.2-1.7-11.4,1.5-11.1,7c0.3,6.6,1.2,13.2,3,19.7c13.1,48.8,63.3,77.8,112.1,64.8c48.8-13,77.8-63.3,64.8-112.1 c-10.6-39.6-45.5-66.2-84.4-67.8c-5.5-0.2-8.8,5.8-7,11.1C318.8,181.9,320,188.4,320,195.2L320,195.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Eye.b97bd216e9eedfea3757f15ce583fcd6.svg";